import URLParser from '../URLParser'

const searchParamsIncludeOne = (...searchParams) => {
  return traffic => {
    const urlObject = new URLParser(traffic.url)
    return searchParams.some(searchParam => {
      const value = urlObject.searchParams.get(searchParam)
      return value !== null
    })
  }
}

export default searchParamsIncludeOne



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/searchParamsIncludeOne.js